/* eslint-disable @typescript-eslint/no-unsafe-return */
import { BaseBehaviorBuilder } from './base_behavior_builder';
import { Behavior } from '../behavior';
export class BehaviorBuilder extends BaseBehaviorBuilder {
    /** @internal */
    static create(codeSpace) {
        const ret = new BehaviorBuilder();
        ret._$codeSpace = codeSpace;
        ret._$ = codeSpace.getComponentSpace().defineWithMethodCaller();
        return ret;
    }
    /** Define a chaining filter */
    chainingFilter(func) {
        this._$chainingFilter = func;
        return this;
    }
    /** Use another behavior */
    behavior(behavior) {
        return super.behavior(behavior);
    }
    /** Set the export value when the component is being selected */
    export(f) {
        return super.export(f);
    }
    /**
     * Add some template data fields
     *
     * It does not support raw data, but a `gen` function which returns the new data fields.
     * The `gen` function executes once during component instance creation.
     */
    data(gen) {
        return super.data(gen);
    }
    /**
     * Add some template data fields
     *
     * The data should be JSON-compatible, and will be cloned during component creation.
     */
    staticData(data) {
        return super.staticData(data);
    }
    /**
     * Add a single property
     *
     * The property name should be different from other properties.
     */
    property(name, def) {
        return super.property(name, def);
    }
    /**
     * Add some public methods
     *
     * The public method can be used as an event handler, and can be visited in component instance.
     */
    methods(funcs) {
        return super.methods(funcs);
    }
    /**
     * Execute a function while component instance creation
     *
     * A `BuilderContext` is provided to tweak the component creation progress.
     * The return value is used as the "export" value of the behavior.
     */
    init(func) {
        return super.init(func);
    }
    /** Apply a classic definition object */
    definition(def) {
        super.definition(def);
        if (def.definitionFilter)
            this._$definitionFilter = def.definitionFilter;
        return this;
    }
    /**
     * Finish the behavior definition process
     */
    register() {
        return new Behavior(this._$.registerBehavior(), this._$parents, this._$definitionFilter, this._$chainingFilter, this._$export);
    }
    /**
     * Add extra this fields type
     */
    extraThisFieldsType() {
        return this;
    }
}
//# sourceMappingURL=behavior_builder.js.map